import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projet-professionnel-entites-item',
  templateUrl: './projet-professionnel-entites-item.component.html',
  styleUrls: ['./projet-professionnel-entites-item.component.scss']
})
export class ProjetProfessionnelEntitesItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
